// src/components/home/Footer.jsx

import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    FaLeaf,
    FaFacebook,
    FaLinkedin,
    FaYoutube,
    FaEnvelope,
    FaPhoneAlt,
    FaMapMarkerAlt
} from "react-icons/fa";

import "../../styles/Footer.css";

export default function Footer() {
const { t } = useTranslation();
    const year = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                <div className="row">
                    {/*================================================*/}
                    {/* FELAHLINK                                      */}
                    {/*================================================*/}

                    <div className="col-lg-4 mb-4">
                        <div className="footer-logo">
                            <FaLeaf className="me-2" />
                            {t("common.felahLink")}
                        </div>

                        <p className="footer-text">

         {t("common.platformDescription")}

                        </p>

                        <div className="footer-social">

                            <a href="#">

                                <FaFacebook />

                            </a>

                            <a href="#">

                                <FaLinkedin />

                            </a>

                            <a href="#">

                                <FaYoutube />

                            </a>

                        </div>

                    </div>

                    {/*================================================*/}
                    {/* Navigation                                     */}
                    {/*================================================*/}

                    <div className="col-lg-2 col-md-6 mb-4">

                        <h5>

                           {t("common.navigation")}

                        </h5>

                        <ul>

                            <li>

                                <Link to="/">

                                    {t("menu.home")}

                                </Link>

                            </li>

                            <li>

                                <Link to="/searchconsultant">

                                    {t("menu.consultant")}

                                </Link>

                            </li>

                            <li>

                                <Link to="/consultationrequest">

                                     {t("menu.consultation")}

                                </Link>

                            </li>

                            <li>

                                <Link to="/about">

                                    {t("common.about")}

                                </Link>

                            </li>

                        </ul>

                    </div>

                    {/*================================================*/}
                    {/* Services                                       */}
                    {/*================================================*/}

                    <div className="col-lg-3 col-md-6 mb-4">

                        <h5>

                             {t("common.services")}

                        </h5>

                        <ul>

                            <li>

                                 {t("common.consultantSearch")}

                            </li>

                            <li>

                                 {t("common.onlineConsultation")}

                            </li>

                            <li>

                                 {t("common.farmManagement")}

                            </li>

                            <li>

                                {t("common.technicalAssistance")}

                            </li>

                        </ul>

                    </div>

                    {/*================================================*/}
                    {/* Contact                                        */}
                    {/*================================================*/}

                    <div className="col-lg-3 mb-4">

                        <h5>

                             {t("common.contact")}

                        </h5>

                        <p>

                            <FaMapMarkerAlt className="me-2 text-success" />

                             {t("common.location")}

                        </p>

                        <p>

                            <FaPhoneAlt className="me-2 text-success" />

                            +213 XX XX XX XX XX

                        </p>

                        <p>

                            <FaEnvelope className="me-2 text-success" />

                            contact@felahlink.dz

                        </p>

                    </div>

                </div>

                <hr />

                {/*================================================*/}
                {/* Copyright                                      */}
                {/*================================================*/}

                <div className="footer-bottom">

                    <div>

                        © {year} <strong>FelahLink</strong>

                    </div>

                    <div>

                        {t("common.version")}

                    </div>

                </div>

            </div>

        </footer>

    );

}